export default function(collection) {
  return {
    array: [...collection.trainings]
  }
}
